import useItemCardLogic from './itemCardLogic';
import '../../../style/cityProfitsItemCard.scss';
import getQualityName from '../../../utils/getQualityName';
import ItemQualities from '../resComponents/itemQualities';
import ItemLocations from '../resComponents/itemCities';
import ItemEnchants from '../resComponents/itemEnchants';

import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

//COMPONENT
function ItemCard({
  itemId,
  itemEnchant,
  itemLocation,
  itemQuality,
  id,
  canEnchant,
  setItemsSelected,
  listItemsSelected,
}) {
  const item = {
    itemLocation,
    itemId,
    itemEnchant,
    itemQuality,
    canEnchant,
    id
  };
  const {
    //STATE
    itemInfoRes,
    itemObj,
    hideQualityList,
    hideLocationList,
    hideEnchantList,
    //SET STATE
    setHideQualityList,
    setHideLocationList,
    setHideEnchantList,
    //VARIABLES
    picUnavailable,
    //FUNCTIONS
    formatPrices,
    deleteItemFromList,
    totalSold,
    updateItem,
    //COMPONENTS
    MdDeleteForever,
  } = useItemCardLogic(setItemsSelected, listItemsSelected, item);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const itemData = payload[0].payload;
      return (
        <div className="tooltip">
          <p className="tooltipDetail">
            Price: ${itemData.avg_price.toLocaleString()}
          </p>
          <p className="tooltipDetail">Sold: {itemData.item_count}</p>
          <p className="tooltipDetail">
            Date:{' '}
            {new Date(itemData.timestamp)
              .toLocaleDateString()
              .split('/', 2)
              .join('/')}
          </p>
        </div>
      );
    }

    return null;
  };
  return (
    <div className={'itemCardContainer'}>
      <div className="itemCardDetailContainer">
        <img
          className={`itemCardImage  enchant${itemEnchant}`}
          title={itemObj.itemName}
          src={`https://albiononline2d.ams3.cdn.digitaloceanspaces.com/thumbnails/orig/${itemObj.itemId}`}
          onError={e => {
            e.target.onerror = null;
            e.target.src = picUnavailable;
          }}
          alt=""
        />
        <div className="itemDetails">
          <div className="itemAttributeContainer">
            <p
              className={`selectionLabel ${itemObj.location}`}
              title="City"
              onClick={() => {
                setHideLocationList(false);
              }}
            >
              {itemObj.location || 'No data'}
            </p>
            <ItemLocations
              gate={hideLocationList}
              setGate={setHideLocationList}
              setLocation={updateItem}
              type="location"
            />
          </div>
          <div className="itemAttributeContainer">
            <p
              className={`selectionLabel enchant${
                itemObj.enchant.split('@')[1]
              }`}
              title="Enchantment"
              onClick={() => {
                setHideEnchantList(false);
              }}
            >
              {itemObj.enchant.includes('@')
                ? 'Enchant ' + itemObj.enchant.split('@')[1]
                : 'None'}
            </p>
            <ItemEnchants
              gate={hideEnchantList}
              setGate={setHideEnchantList}
              setEnchant={updateItem}
              type="enchant"
              canEnchant={itemObj.canEnchant}
            />
          </div>
          <div className="itemAttributeContainer">
            <p
              className={`selectionLabel quality${itemObj.quality}`}
              title="Quality"
              onClick={() => {
                setHideQualityList(false);
              }}
            >
              {getQualityName(itemObj.quality)}
            </p>
            <ItemQualities
              gate={hideQualityList}
              setGate={setHideQualityList}
              setQuality={updateItem}
              type="quality"
            />
          </div>
        </div>
      </div>
      <div className="itemCardItemInfo">
        {itemInfoRes ? (
          <div className="itemCardChart">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width={500}
                height={300}
                data={itemInfoRes.data}
                margin={{
                  top: 10,
                  right: 20,
                  left: 20,
                  bottom: 10,
                }}
              >
                <CartesianGrid strokeDasharray="1 1" />
                <XAxis dataKey="timestamp" hide={true} scale={10} />
                <YAxis dataKey="item_count" hide={true} tickCount={500} />
                <Tooltip content={<CustomTooltip active />} />

                <Line type="monotone" dataKey="item_count" stroke="black" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        ) : (
          <div className="itemCardNoData">
            Not enough data is provided for this item.
          </div>
        )}

        <div
          title={`Recently Sold For`}
          className={`itemCardPriceInfoContainer`}
        >
          $
          {itemInfoRes
            ? formatPrices(
                itemInfoRes.data[itemInfoRes.data.length - 1].avg_price
              )
            : 'No Data'}
          <span>Recently Sold For</span>
        </div>
        <div
          title={`Total sold in 30 days.`}
          className={`itemCardPriceInfoContainer`}
        >
          {itemInfoRes
            ? totalSold(itemInfoRes.data).toLocaleString()
            : 'No Data'}
          <span>Total Sold in 30 Days</span>
        </div>
      </div>
      <div className={'itemCardDelete'}>
        <MdDeleteForever
          onClick={() => deleteItemFromList(itemObj.id)}
          title={'Delete this item.'}
          className={'itemCardDeleteButton'}
        />
      </div>
    </div>
  );

}

export default ItemCard;
